export const isValidationSuccess = (info) => !info?.length;
export const isValidationErr = (info) => Boolean(info?.length);
export const validator = (predicate) => (message) => (_) => predicate(_) ? [] : [message];
//# sourceMappingURL=validator.js.map